import { makeStyles } from '@material-ui/core/styles'

export const camdenDiningStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: 443,
    maxHeight: 443,
    overflowY: 'auto',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 231px)',
    },
  },
  rootNotes: {
    width: '100%',
    height: 403,
    maxHeight: 403,
    overflowY: 'auto',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 271px)',
    },
  },
  diningCard: {
    width: '95%',
    borderRadius: '10px',
    margin: '0 auto 10px auto',
    '&:hover': {
      cursor: 'pointer',
    },
    '&:focus-visible': {
      outline: `1px solid ${theme.palette.button.focusBorder}`,
      boxShadow: `0 0 0 3px ${theme.palette.button.focusOutline}`,
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  icon: {
    fontSize: 35,
    color: theme.palette.components.icon,
  },
  offlineContainer: {
    background: theme.palette.backgroundColor.ternary,
    margin: 5,
    padding: 5,
    color: theme.palette.primary.main,
  },
  menuButtonsSection: {
    display: 'flex',
    justifyContent: 'space-evenly',
    paddingTop: 10,
    paddingBottom: 10,
  },
  menuButtonBase: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2px',
    width: '100px',
    '&:focus-visible': {
      outline: `1px solid ${theme.palette.button.focusBorder}`,
      boxShadow: `0 0 0 3px ${theme.palette.button.focusOutline}`,
      backgroundColor: theme.palette.button.hover,
      borderRadius: '4px',
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.button.hover,
      borderRadius: '4px',
    },
  },
}))
